import { FirestoreDataConverter } from '../node_modules/firebase/firestore/dist/firestore';

export default class InnerStatus {
  constructor (
    public id?: string,
    public value?: string,
    public order?: number
  ) {}

  toString() {
      return this.value;
  }
}

export const INNER_STATUS = 'inner_statuses';
export const DefaultInnerStatus = {
  escalated: 'escalated',
  descalated: 'descalated',
  holdByOtherDep: 'holdByOtherDep',
}
export const DefaultInnerStatusJp = {
  escalated: 'エスカ中',
  descalated: 'デスカ済',
  holdByOtherDep: '他部署確認中',
}
export const innerStatusConverter: FirestoreDataConverter<InnerStatus> = {
  toFirestore: (innerStatus) => {
    return {
      value: innerStatus.value,
      order: innerStatus.order,
    };
  },

  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    return new InnerStatus(snapshot.id,
      data.value,
      data.order
    );
  }
};
